import React from "react";

const Cta = () => {
  return (
    <div className="subscribe_area pt-10 pb-45">
     
       <div className="col-lg-12">
            
            <a href="/contact-us"> 
            <img
              src="assets/images/icon/accounts.gif" 
              alt="Subscribe" 
              className="mx-auto mb-4 w-32"
            /></a> 
         
         
        </div>
    </div>
  );
};

export default Cta;
